import React from 'react'

import { useRemoteStrings } from '@acorns/web-utils'

import { useBlueprintBindings } from '../utils/blueprint-bindings-context'
import type { GroveBlueprintComponentProps } from '../utils/grove-blueprint-component-props'
import { resolveAssetSource } from '../utils/resolve-asset-source'
import { resolveModifiers } from '../utils/resolve-modifiers'

export function GroveBlueprintImage({ node }: GroveBlueprintComponentProps) {
  const { getRemoteString } = useRemoteStrings()
  const { bindingValues } = useBlueprintBindings()

  /* v8 ignore if -- @preserve */
  if (node.type !== 'Image') {
    return null
  }

  const { className, style, attributes } = resolveModifiers(
    node.modifiers,
    bindingValues,
    (key: string) => getRemoteString({ key }),
  )

  const src = resolveAssetSource(node.props.source)

  if (node.props.source.type === 'local') {
    const localStyle = {
      ...style,
      height: style.height ?? style.width,
    }

    const hasAccessibilityLabel = attributes['aria-label'] !== undefined

    return (
      <div
        aria-hidden={hasAccessibilityLabel ? undefined : true}
        className={`shrink-0 bg-current mask-auto mask-no-repeat mask-center ${className}`.trim()}
        role={'img'}
        style={{
          ...localStyle,
          WebkitMaskImage: `url(${src})`,
          maskImage: `url(${src})`,
        }}
        {...attributes}
      />
    )
  }

  const { 'aria-label': ariaLabel, ...restAttributes } = attributes

  return (
    <div
      className={`flex items-center justify-center ${className}`.trim()}
      style={style}
      {...restAttributes}
    >
      <img alt={ariaLabel ?? ''} src={src} />
    </div>
  )
}
